module.exports = __webpack_public_path__ + "static/img/copy.78f78b7e.png";